import { useEffect, useState } from "react";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import "./Layout.css";

const DRAWER_WIDTH_OPEN = 260;
const DRAWER_WIDTH_CLOSED = 72;

function Layout() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (document.getElementById("app-js")) return;
    const script = document.createElement("script");
    script.id = "app-js";
    script.src = `${process.env.PUBLIC_URL}/assets/js/app.js`;
    script.async = false;
    document.body.appendChild(script);
  }, []);

  const drawerWidth = collapsed ? DRAWER_WIDTH_CLOSED : DRAWER_WIDTH_OPEN;

  return (
    <div id="layout-wrapper" style={{ "--drawer-width": `${drawerWidth}px` }}>
      <Header collapsed={collapsed} />
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="vertical-overlay"></div>
      <div className="main-content">
        <Outlet />
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
